module.exports = __webpack_public_path__ + "img/10.76a2a7fc.jpg";